module.exports = __webpack_public_path__ + "img/Quoted.ba3ac378.svg";